import { Component, OnInit, Inject } from "@angular/core";
import { PhysicianService } from "../../../services/physician.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FilterCompleteService } from "../../../filter-complete/filter-complete";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ValidateAutoCompleteSelect } from "../../../validators/autocomplete-select.validator";
import { EquipmentFilter } from "../../../model/equipment-filter";
import { EquipmentService } from "../../../services/equipment.service";

@Component({
  selector: 'equipment-replacement-dialog',
  templateUrl: 'equipment-replacement-dialog.component.html',
  styleUrls: ['./equipment-replacement-dialog.component.css']
})
export class EquipmentReplacementDialogComponent implements OnInit {

  loading: boolean;
  filterCompleteEquipments: FilterCompleteService<EquipmentFilter>;
  existsEquipments: boolean;
  form: FormGroup;

  constructor(private equipmentService: EquipmentService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<EquipmentReplacementDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.form = this.formBuilder.group({
      Equipment: ['', [Validators.required, ValidateAutoCompleteSelect]]
    });

    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>([], this.form.controls.Equipment);
  }

  get filteredEquipmentsOptions() { return this.filterCompleteEquipments ? this.filterCompleteEquipments.filteredOptions : []; }
  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.form.invalid) {
        this.loading = true;
        await this.equipmentService.replacementMedicalApponitmentEquipment({
          MedicalAppointmentId: this.data.medicalAppointmentId
          , EquipmentId: (<EquipmentFilter>this.form.getRawValue().Equipment).Id
        })
        this.notificationToastService.success("Se ha reemplazado el equipo correctamente", "Reemplazo de equipo");
        this.dialogRef.close(<EquipmentFilter>this.form.getRawValue().Equipment);
      }
    }
    catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reemplazo de equipo");
    } finally {
      this.loading = false;
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      const equipmentsFilter = await this.equipmentService.getReplacementEquipmentFilter(this.data.medicalAppointmentId);
      this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>(equipmentsFilter, this.form.controls.Equipment);
      this.form.patchValue({ Physician: null });
      this.existsEquipments = equipmentsFilter.length > 0;
    }
    catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reemplazo de equipo");
    } finally {
      this.loading = false;
    }
  }
}
